import React from 'react';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#0A0E27] text-gray-300">
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <a href="/" className="inline-flex items-center space-x-2 text-[#00D9FF] hover:text-white transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" />
          <span>Back to Home</span>
        </a>

        <h1 className="text-4xl font-bold text-white mb-2">Privacy Policy</h1>
        <p className="text-gray-500 mb-10">Last updated: {new Date().toLocaleDateString('en-ZA', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-white mb-3">1. Introduction</h2>
            <p>Chill Point ("we", "us", or "our") operates the Chill Point website. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website and services.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">2. Information We Collect</h2>
            <p className="mb-3">We collect the following information when you submit a quote request or contact us:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Full name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Service requirements and messages</li>
            </ul>
            <p className="mt-3">We may also collect non-personal information such as browser type, device information, and website usage data through analytics tools to improve our services.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">3. How We Use Your Information</h2>
            <p className="mb-3">We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Respond to your service enquiries and quote requests</li>
              <li>Schedule and provide HVAC services</li>
              <li>Communicate with you about your service requirements</li>
              <li>Improve our website and services</li>
              <li>Send relevant service reminders (only with your consent)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">4. Data Sharing</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. Your information may only be shared with trusted service providers who assist us in operating our website and conducting our business, provided they agree to keep this information confidential.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">5. Data Security</h2>
            <p>We implement reasonable security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">6. Cookies & Analytics</h2>
            <p>Our website uses cookies and analytics tools (including Google Analytics) to understand how visitors use our site. These tools collect information such as how often users visit, what pages they visit, and what other sites they used prior to coming to our site. You can disable cookies through your browser settings.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">7. Your Rights</h2>
            <p className="mb-3">In accordance with the Protection of Personal Information Act (POPIA) of South Africa, you have the right to:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Request access to the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your personal information</li>
              <li>Object to the processing of your personal information</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">8. Contact Us</h2>
            <p className="mb-3">If you have questions about this Privacy Policy or wish to exercise your rights, contact us at:</p>
            <ul className="space-y-1">
              <li><strong className="text-white">Email:</strong> chillpointexec@gmail.com</li>
              <li><strong className="text-white">Phone:</strong> 064 450 5026</li>
              <li><strong className="text-white">Location:</strong> Ballito, KwaZulu-Natal, South Africa</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">9. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
